import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="chat-sound"
export default class extends Controller {
  static values = {
    url: String,
  };

  connect() {
    // 1. Pre-load the audio so it plays instantly
    this.audio = new Audio(this.urlValue);

    // 2. Watch this HTML element for changes
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // If a new element (like a Turbo Stream message) was added...
        if (mutation.addedNodes.length > 0) {
          this.playSound();
        }
      });
    });

    // 3. Start watching!
    this.observer.observe(this.element, { childList: true });
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  playSound() {
    // Reset to 0 in case messages come in fast
    this.audio.currentTime = 0;

    // The browser might block the sound if the user hasn't tapped anything yet.
    // The catch block prevents the app from crashing if that happens.
    this.audio.play().catch((error) => {
      console.log(
        "Audio autoplay blocked by browser until user interacts.",
        error,
      );
    });
  }
}
